import React, { Component } from 'react'
import '../stylesheets/main.scss'
import Menu from './Menu'
import Dashresultslist from './Dashresultslist'
import link from './Tags'

class Header extends Component{

	render(){
		return (
      <section className="o-header" id="home">
        <div className="o-container">
          
          <Menu />

          <p className="c-title c-title--size-small c-title--weight-regular c-title--color-white c-title--align-center">
            O Caminhão da Serasa continua a sua missão:
          </p>

          <p className="c-title c-title--size-big c-title--family-black c-title--color-white c-title--align-center o-uppercase">
            Levar acesso à informação <br /> para quem não possui.
          </p>

          <ul className="o-list o-list--display o-list--display-inline o-list--align o-list--align-center ">
            <li>
              <a href="#onde-estamos" className="c-btn c-btn--width c-btn--width-small c-btn--color c-btn--color-purple c-btn--shadow-purple" onClick={ (e) => { link({tagaction: 'informacao-geral', tagtitle: 'roteiro-completo'}, e) } }>Roteiro completo</a>
            </li>
            <li>
              <a href="#sobre" className="c-btn c-btn--width c-btn--width-small c-btn--color c-btn--color-transparent" onClick={ (e) => { link({tagaction: 'informacao-geral', tagtitle: 'sobre-o-projeto'}, e) } } >Sobre o projeto</a>
            </li>
          </ul>

          <Dashresultslist />

        </div>

        <img src={ process.env.PUBLIC_URL + "/images/cities-header.png" } className="o-header--footer" alt="" />
      </section>
		)
	}

}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js